import "./styles.css";
import {ACTIVITY_TYPE, AllActivityTypes} from "../../../../../types-enums/activity";
import React, {useContext} from "react";
import {DelayedSpinner, Icon, IconButton} from "atmosfair-ui"
import {useDraggable} from "@dnd-kit/core";

import {CreateJourneyFromTravelComponentsDayCardPropsContext, isValidDay} from "../../../common";
import {renderActivityForJourney} from "../../common";
import {DELAY_TIME_FOR_SPINNER} from "../../../../../utils/common";
import {theme} from "../../../../../styles/theme";
import {ALL_ACTIVITIES} from "../../create-journey-from-travel-components/CreateJourneyFromTravelComponents";

export interface CardListItemProps {
    activity: AllActivityTypes,
    isInitialGroup: boolean,
    loading: boolean,
}

const setDisableHotelArrowDown = (
    activity: AllActivityTypes,
    droppableZoneId: string,
    journeyDurationInDays: number | undefined,
    day: number | undefined
) => {
    let arrowDownDisabled = false
    const {common: {activityType}} = activity
    if (
        droppableZoneId === ALL_ACTIVITIES &&
        journeyDurationInDays === 1 &&
        activityType === ACTIVITY_TYPE.hotel
    ) {
        arrowDownDisabled = true
    } else {
        if (typeof journeyDurationInDays !== 'undefined' && day === journeyDurationInDays - 1) arrowDownDisabled = true
    }
    return arrowDownDisabled
}

const CreateJourneyFromTravelComponentsCardItem = ({
                                                       activity,
                                                       isInitialGroup,
                                                       loading,
                                                   }: CardListItemProps) => {
    const {
        droppableZoneId,
        onActivityDelete,
        onActivityArrowDown,
        onActivityArrowUp,
        hasExactDates,
        day,
        journeyDurationInDays,
        allActivities
    } = useContext(CreateJourneyFromTravelComponentsDayCardPropsContext)
    const {common: {id: activityId, activityType}} = activity
    const {attributes, listeners, setNodeRef} = useDraggable({
        id: activityId,
        disabled: loading,
        data: {droppableZoneId, activity}
    })
    const color = isInitialGroup ? "primary" : "white"
    const isDroppableZoneDay = isValidDay(droppableZoneId)
    const arrowDownDisabled = day === journeyDurationInDays
    const disableHotelArrowDown = setDisableHotelArrowDown(activity,
        droppableZoneId,
        journeyDurationInDays,
        day
    )

    const {
        ActivityStringComponent,
        EmissionsCo2KgEComponent
    } = renderActivityForJourney(
        activity,
        allActivities,
        hasExactDates,
        isDroppableZoneDay ? "white" : 'black',
        loading,
        isInitialGroup ? theme.colors.black : theme.colors.white,
        isInitialGroup,
        false
    )

    const _generateTooltip = () => {
        if (activityType === ACTIVITY_TYPE.hotel && disableHotelArrowDown) return "HINTS.JOURNEY.ARROW_DOWN_HOTEL_ACTIVITY_DISABLED"
        return "TOOLTIP.COMMON.MOVE_ONE_DAY_DOWN"
    }

    return <div
        style={{display: 'flex'}}
        ref={setNodeRef}
        {...listeners}
        {...attributes}>
        <li className={'create-journey-from-travel-components-card-item-container'}>
            <div
                className={'create-journey-from-travel-components-card-item-name-wrapper'}>
                {loading &&
                    <DelayedSpinner
                        fullscreen={false}
                        delayMs={DELAY_TIME_FOR_SPINNER}
                        size={10}
                        color={isInitialGroup ? "primary" : "white"}/>}
                <Icon
                    color={isInitialGroup ? "black" : "white"}
                    size={'verySmall'}
                    icon={"grip"}/>
                <div className={'create-journey-from-travel-components-card-item-activity-wrapper'}>
                    {ActivityStringComponent}
                    {EmissionsCo2KgEComponent}
                </div>
            </div>
        </li>
        <div className={'create-journey-from-travel-components-card-item-icon-wrapper'}>
            <IconButton
                disabled={droppableZoneId === ALL_ACTIVITIES || loading}
                tooltip={"TOOLTIP.COMMON.MOVE_ONE_DAY_UP"}
                icon={"circleUp"}
                color={color}
                onClick={() => onActivityArrowUp && onActivityArrowUp(activity)}
                size={'verySmall'}/>
            <IconButton
                disabled={arrowDownDisabled || disableHotelArrowDown || loading}
                tooltip={_generateTooltip()}
                icon={"circleDown"}
                color={color}
                onClick={() => onActivityArrowDown(activity)}
                size={'verySmall'}/>
            <IconButton
                disabled={loading}
                tooltip={"TOOLTIP.COMMON.DELETE_TRAVEL_COMPONENT"}
                icon={"trash"}
                onClick={() => onActivityDelete(activity)}
                color={color}
                size={'verySmall'}/>
        </div>
    </div>
}

export default CreateJourneyFromTravelComponentsCardItem;